import {Route,Routes} from "react-router-dom";
import { Home } from "../pages/Home";
import { Store } from "../pages/Store";
import { Confirmation } from "../pages/Confirmation";
import { Messages } from "../pages/Messages";


export function MainRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/store" element={<Store />} />
      <Route path="/confirmation" element={<Confirmation />} />
      <Route path="/message" element={<Messages />} />
    </Routes>
  );
}